import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_APP018_Request,
  IAPI_APP018_Response,
} from "../../../type/apiType";
import {
  IAPI_APP010_Request,
  IAPI_APP010_Response,
} from "../../../type/apiType";
import {
  IAPI_APP011_Request,
  IAPI_APP011_Response,
} from "../../../type/apiType";
import {
  IAPI_APP016_Request,
  IAPI_APP016_Response,
} from "../../../type/apiType";

/**
 * 退職手当金支給決定額の証明依頼 法人参照API
 * @return httpAPI_APP018
 */
const httpAPI_APP018 = async (
  param: IAPI_APP018_Request
): Promise<IAPI_APP018_Response> => {
  const res = await http.post(ApiUrl.API_APP018, {
    ...param,
  });

  return res.data;
};

/**
 * 退職手当金支給決定額の証明依頼　更新API
 * @return httpAPI_APP010
 */
const httpAPI_APP010 = async (
  param: IAPI_APP010_Request
): Promise<IAPI_APP010_Response> => {
  const res = await http.post(ApiUrl.API_APP010, {
    ...param,
  });

  return res.data;
};

/**
 * 退職手当金支給決定額の証明依頼　回答更新API
 * @return httpAPI_APP011
 */
const httpAPI_APP011 = async (
  param: IAPI_APP011_Request
): Promise<IAPI_APP011_Response> => {
  const res = await http.post(ApiUrl.API_APP011, {
    ...param,
  });

  return res.data;
};

/**
 * 申請状況更新API
 * @return httpAPI_APP016
 */
const httpAPI_APP016 = async (
  param: IAPI_APP016_Request
): Promise<IAPI_APP016_Response> => {
  const res = await http.post(ApiUrl.API_APP016, {
    ...param,
  });

  return res.data;
};

export { httpAPI_APP018, httpAPI_APP010, httpAPI_APP011, httpAPI_APP016 };
